import router from './router'
import store from './store'
import {getToken} from '@/utils/auth'
import {Message} from 'element-ui'

function hasPermission(roles, permissionRoles) {
  if (roles.indexOf('ROLE_ADMIN') >= 0 || roles.indexOf('ROLE_WAITER') >= 0) return true
  if (!permissionRoles) return true
  return roles.some(userRole => permissionRoles.some(routeRole => routeRole === userRole))
  // return roles.some(role => permissionRoles.indexOf(role) >= 0)
}

const whiteList = ['/login', '/authredirect']

router.beforeEach((to, from, next) => {
  if (getToken()) {
    if (to.path === '/login') {
      next({path: '/'})
    } else {
      if (store.getters.roles.length === 0) {
        store.dispatch('GetUserInfo').then(res => {
          const roles = res.data.roles
          store.dispatch('GenerateRoutes', {roles}).then(() => {
            router.addRoutes(store.getters.addRouters)
            if (roles.includes('ROLE_HOOKAH')) {
              router.push('/move-hookah')
            } else {
              next({...to})
            }
          })
        }).catch(err => {
          console.log(`getUser Err ${err}`)
          if (err.response && err.response.status === 403) Message.error('Отказано в доступе')
        })
      } else {
        if (hasPermission(store.getters.roles, to.meta.roles)) {
          next()//
        } else {
          next({path: '/401'})
        }
      }
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      next()
    } else {
      next('/login')
    }
  }
})



// WEBPACK FOOTER //
// ./src/permission.js